import { MenuItem2 } from "@blueprintjs/popover2";
import { ItemRendererProps } from "@blueprintjs/select";
import classNames from "classnames";
import React from "react";

import { SelectItem } from "../types";
import { getItemProps } from "../utils";
import styles from "./item.module.scss";

export interface ItemRendererExtendedProps extends ItemRendererProps {
  selected: boolean;
}

export interface ItemRendererComponentProps {
  item: SelectItem;
  props: ItemRendererExtendedProps;
}

export const Item = ({ item, props }: ItemRendererComponentProps) => {
  // eslint-disable-next-line react/prop-types
  if (!props.modifiers.matchesPredicate) {
    return null;
  }

  return (
    <MenuItem2
      {...getItemProps(item, props)}
      // eslint-disable-next-line react/prop-types
      className={classNames(styles.menuItem, { [styles.selected || ""]: props.selected })}
      key={item.id}
      text={item.label}
    />
  );
};
